const getEnvValue = name => {
  const runtimeValue = globalThis._env_?.[name];

  if (runtimeValue !== undefined) {
    return runtimeValue;
  }

  // Fall back to process.env on the server. globalThis._env_ is populated from
  // instrumentation.js register(), but a module evaluated before that runs -
  // or a runtime where register() never fires - would otherwise see nothing at
  // all. getPublicOrigin, requestLog.js and logger.mjs all already have this
  // fallback; without it here, isProd() silently resolves to false in
  // production, which is enough to noindex the entire site (CON-8595).
  //
  // Guarded because `process` is not defined in the browser, and a dynamic key
  // cannot be statically inlined by the bundler there in any case.
  return typeof process !== 'undefined' ? process.env?.[name] : undefined;
};

export default getEnvValue;
